import React, { useEffect, useRef, useCallback, useState } from 'react';
import SignaturePad from 'signature_pad';

function FirmaPad({ sigRef, canvasProps }) {
  const canvasWrapperRef = useRef(null);
  const canvasRef = useRef(null);
  const localSigPad = useRef(null);
  const [errorCount, setErrorCount] = useState(0);

  const initSignaturePad = useCallback((restoreData = null) => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    // Destruir instancia anterior
    if (localSigPad.current) {
      localSigPad.current.off();
      localSigPad.current = null;
    }

    localSigPad.current = new SignaturePad(canvas, {
      penColor: 'darkblue',
      minWidth: 0.5,
      maxWidth: 2.5,
    });

    if (restoreData) {
      try {
        localSigPad.current.fromData(restoreData);
      } catch {
        // Si no se puede restaurar, ignoramos
      }
    }

    if (sigRef) {
      sigRef.current = localSigPad.current;
    }
  }, [sigRef]);

  const resizeCanvas = useCallback(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    let data = null;
    if (localSigPad.current && !localSigPad.current.isEmpty()) {
      try {
        data = localSigPad.current.toData();
      } catch (error) {
        console.warn("Error leyendo la firma, reiniciando...", error);
        setErrorCount(c => c + 1);
        return;
      }
    }

    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    const width = canvasWrapperRef.current.clientWidth;
    const height = canvasProps.height || 150;

    canvas.width = width * ratio;
    canvas.height = height * ratio;
    canvas.style.width = `${width}px`;
    canvas.style.height = `${height}px`;

    const ctx = canvas.getContext('2d');
    ctx.scale(ratio, ratio);

    initSignaturePad(data);
  }, [canvasProps.height, initSignaturePad]);

  useEffect(() => {
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    return () => {
      window.removeEventListener('resize', resizeCanvas);
      if (localSigPad.current) {
        localSigPad.current.off();
        localSigPad.current = null;
      }
      if (sigRef) sigRef.current = null;
    };
  }, [resizeCanvas, sigRef]);

  // Si hay errores, reinicia automáticamente
  useEffect(() => {
    if (errorCount > 0) {
      resizeCanvas();
    }
  }, [errorCount, resizeCanvas]);

  return (
    <div ref={canvasWrapperRef} style={{ position: 'relative', width: '100%' }}>
      <canvas ref={canvasRef} className="sigCanvas" />
      <button
        type="button"
        onClick={() => resizeCanvas()}
        style={{
          position: 'absolute',
          top: '5px',
          right: '5px',
          fontSize: '0.8rem',
          padding: '2px 6px',
          backgroundColor: '#fff',
          border: '1px solid #ccc',
          borderRadius: '4px',
          cursor: 'pointer',
        }}
      >
        ↻
      </button>
    </div>
  );
}

export default FirmaPad;